import { n as e, t } from "./BlockNoteExtension-BBlRdZNO.js";
import { t as n } from "./ShowSelection-uhJZ_3aM.js";
import { t as r } from "./EventEmitter-CbNteBMb.js";
import { t as i } from "./ThreadStore-ielskc3v.js";
import { Mark as a, mergeAttributes as o } from "@tiptap/core";
import { Plugin as s, PluginKey as c } from "prosemirror-state";
import { Decoration as l, DecorationSet as u } from "prosemirror-view";
//#region src/comments/mark.ts
var d = a.create({
	name: "comment",
	excludes: "",
	inclusive: !1,
	keepOnSplit: !0,
	addAttributes() {
		return {
			orphan: {
				parseHTML: (e) => !!e.getAttribute("data-orphan"),
				renderHTML: (e) => e.orphan ? { "data-orphan": "true" } : {},
				default: !1
			},
			threadId: {
				parseHTML: (e) => e.getAttribute("data-bn-thread-id"),
				renderHTML: (e) => ({ "data-bn-thread-id": e.threadId }),
				default: ""
			}
		};
	},
	renderHTML({ HTMLAttributes: e }) {
		return ["span", o(e, { class: "bn-thread-mark" })];
	},
	parseHTML() {
		return [{ tag: "span.bn-thread-mark" }];
	},
	extendMarkSchema(e) {
		return e.name === "comment" ? { blocknoteIgnore: !0 } : {};
	}
}), f = class extends r {
	userCache = /* @__PURE__ */ new Map();
	loadingUsers = /* @__PURE__ */ new Set();
	constructor(e) {
		super(), this.resolveUsers = e;
	}
	async loadUsers(e) {
		let t = e.filter((e) => !this.userCache.has(e) && !this.loadingUsers.has(e));
		if (t.length !== 0) {
			for (let e of t) this.loadingUsers.add(e);
			try {
				let e = await this.resolveUsers(t);
				for (let t of e) this.userCache.set(t.id, t);
				this.emit("update", this.userCache);
			} finally {
				for (let e of t) this.loadingUsers.delete(e);
			}
		}
	}
	getUser(e) {
		return this.userCache.get(e);
	}
	subscribe(e) {
		return this.on("update", e);
	}
}, p = new c("blocknote-comments");
function m(e, t) {
	let n = /* @__PURE__ */ new Map();
	return e.descendants((e, r) => {
		e.marks.forEach((i) => {
			if (i.type.name === t) {
				let t = i.attrs.threadId;
				if (!t) return;
				let a = r, o = a + e.nodeSize, s = n.get(t) ?? {
					from: Infinity,
					to: 0
				};
				n.set(t, {
					from: Math.min(a, s.from),
					to: Math.max(o, s.to)
				});
			}
		});
	}), n;
}
var h = t(({ editor: t, options: { schema: r, threadStore: i, resolveUsers: a } }) => {
	if (!a) throw Error("resolveUsers is required to be defined when using comments");
	if (!i) throw Error("threadStore is required to be defined when using comments");
	let o = d.name, c = new f(a), h = e({
		pendingComment: !1,
		selectedThreadId: void 0,
		threadPositions: /* @__PURE__ */ new Map()
	}, { onUpdate() {
		h.state.selectedThreadId !== h.prevState.selectedThreadId && t.transact((e) => e.setMeta(p, !0));
	} }), g = (e) => {
		t.transact((t) => {
			t.doc.descendants((n, r) => {
				n.marks.forEach((i) => {
					if (i.type.name === o) {
						let a = i.type, o = i.attrs.threadId, s = e.get(o), c = !!(!s || s.resolved || s.deletedAt);
						if (c !== i.attrs.orphan) {
							let e = Math.max(r, 0), s = Math.min(r + n.nodeSize, t.doc.content.size - 1, t.doc.content.size - 1);
							t.removeMark(e, s, i), t.addMark(e, s, a.create({
								...i.attrs,
								orphan: c
							})), c && h.state.selectedThreadId === o && h.setState((e) => ({
								...e,
								selectedThreadId: void 0
							}));
						}
					}
				});
			});
		});
	};
	return {
		key: "comments",
		store: h,
		runsBefore: ["link"],
		tiptapExtensions: [d],
		prosemirrorPlugins: [new s({
			key: p,
			state: {
				init() {
					return { decorations: u.empty };
				},
				apply(e, t) {
					let n = e.getMeta(p);
					if (!e.docChanged && !n) return t;
					let r = e.docChanged ? m(e.doc, o) : h.state.threadPositions;
					(r.size > 0 || h.state.threadPositions.size > 0) && h.setState((e) => ({
						...e,
						threadPositions: r
					}));
					let i = [];
					if (h.state.selectedThreadId) {
						let e = r.get(h.state.selectedThreadId);
						e && i.push(l.inline(e.from, e.to, { class: "bn-thread-mark-selected" }));
					}
					return { decorations: u.create(e.doc, i) };
				}
			},
			props: {
				decorations(e) {
					return p.getState(e)?.decorations ?? u.empty;
				},
				handleClick: (e, t, n) => {
					if (n.button !== 0) return !1;
					let r = e.state.doc.nodeAt(t);
					if (!r) return h.setState((e) => ({
						...e,
						selectedThreadId: void 0
					})), !1;
					let i = r.marks.find((e) => e.type.name === o && e.attrs.orphan !== !0);
					if (!i) return h.state.selectedThreadId !== void 0 && h.setState((e) => ({
						...e,
						selectedThreadId: void 0
					})), !1;
					let a = i.attrs.threadId;
					return a === h.state.selectedThreadId ? !1 : (h.setState((e) => ({
						...e,
						selectedThreadId: a
					})), !0);
				}
			}
		})],
		threadStore: i,
		mount() {
			let e = i.subscribe(g);
			g(i.getThreads());
			let n = t.onSelectionChange(() => {
				h.state.pendingComment && h.setState((e) => ({
					...e,
					pendingComment: !1
				}));
			});
			return () => {
				e(), n();
			};
		},
		selectThread(e, n = !0) {
			if (h.state.selectedThreadId !== e && (h.setState((t) => ({
				...t,
				pendingComment: !1,
				selectedThreadId: e
			})), e && n)) {
				let n = h.state.threadPositions.get(e);
				if (!n) return;
				(t.prosemirrorView?.domAtPos(n.from).node)?.scrollIntoView({
					behavior: "smooth",
					block: "center"
				});
			}
		},
		startPendingComment() {
			h.setState((e) => ({
				...e,
				selectedThreadId: void 0,
				pendingComment: !0
			})), t.domElement?.focus(), t.getExtension(n)?.showSelection(!0, "comments");
		},
		stopPendingComment() {
			h.setState((e) => ({
				...e,
				selectedThreadId: void 0,
				pendingComment: !1
			})), t.getExtension(n)?.showSelection(!1, "comments");
		},
		async createThread(e) {
			let n = await i.createThread(e);
			i.addThreadToDocument ? await i.addThreadToDocument({
				threadId: n.id,
				selection: t.transact((e) => e.selection)
			}) : t._tiptapEditor.commands.setMark(o, {
				orphan: !1,
				threadId: n.id
			});
		},
		userStore: c,
		commentEditorSchema: r
	};
}), g = class {}, _ = class extends g {
	constructor(e, t) {
		super(), this.userId = e, this.role = t;
	}
	canCreateThread() {
		return !0;
	}
	canAddComment(e) {
		return !0;
	}
	canUpdateComment(e) {
		return e.userId === this.userId;
	}
	canDeleteComment(e) {
		return e.userId === this.userId || this.role === "editor";
	}
	canDeleteThread(e) {
		return this.role === "editor";
	}
	canResolveThread(e) {
		return !0;
	}
	canUnresolveThread(e) {
		return !0;
	}
	canAddReaction(e, t) {
		return t ? !e.reactions.some((e) => e.emoji === t && e.userIds.includes(this.userId)) : !0;
	}
	canDeleteReaction(e, t) {
		return t ? e.reactions.some((e) => e.emoji === t && e.userIds.includes(this.userId)) : !0;
	}
}, v = class extends i {
	constructor(e, t, n) {
		super(n), this.userId = e, this.provider = t;
	}
	async createThread(e) {
		let t = this.provider.createThread({ data: e.metadata });
		return t = this.provider.addComment(t.id, {
			content: e.initialComment.body,
			data: {
				metadata: e.initialComment.metadata,
				userId: this.userId
			}
		}), this.tiptapThreadToThreadData(t);
	}
	addThreadToDocument = void 0;
	async addComment(e) {
		let t = this.provider.addComment(e.threadId, {
			content: e.comment.body,
			data: {
				metadata: e.comment.metadata,
				userId: this.userId
			}
		});
		return this.tiptapCommentToCommentData(t.comments[t.comments.length - 1]);
	}
	async updateComment(e) {
		let t = this.provider.getThreadComment(e.threadId, e.commentId, !0);
		if (!t) throw Error("Comment not found");
		this.provider.updateComment(e.threadId, e.commentId, {
			content: e.comment.body,
			data: {
				...t.data,
				metadata: e.comment.metadata
			}
		});
	}
	tiptapCommentToCommentData(e) {
		let t = [];
		for (let n of e.data?.reactions || []) {
			let e = t.find((e) => e.emoji === n.emoji);
			e ? (e.userIds.push(n.userId), e.createdAt = new Date(Math.min(e.createdAt.getTime(), n.createdAt))) : t.push({
				emoji: n.emoji,
				createdAt: new Date(n.createdAt),
				userIds: [n.userId]
			});
		}
		return {
			type: "comment",
			id: e.id,
			body: e.content,
			metadata: e.data?.metadata,
			userId: e.data?.userId,
			createdAt: new Date(e.createdAt),
			updatedAt: new Date(e.updatedAt),
			reactions: t
		};
	}
	tiptapThreadToThreadData(e) {
		return {
			type: "thread",
			id: e.id,
			comments: e.comments.map((e) => this.tiptapCommentToCommentData(e)),
			resolved: !!e.resolvedAt,
			metadata: e.data?.metadata,
			createdAt: new Date(e.createdAt),
			updatedAt: new Date(e.updatedAt)
		};
	}
	async deleteComment(e) {
		this.provider.deleteComment(e.threadId, e.commentId);
	}
	async deleteThread(e) {
		this.provider.deleteThread(e.threadId);
	}
	async resolveThread(e) {
		this.provider.updateThread(e.threadId, { resolvedAt: (/* @__PURE__ */ new Date()).toISOString() });
	}
	async unresolveThread(e) {
		this.provider.updateThread(e.threadId, { resolvedAt: null });
	}
	async addReaction(e) {
		let t = this.provider.getThreadComment(e.threadId, e.commentId, !0);
		if (!t) throw Error("Comment not found");
		this.provider.updateComment(e.threadId, e.commentId, { data: {
			...t.data,
			reactions: [...t.data?.reactions || [], {
				emoji: e.emoji,
				createdAt: Date.now(),
				userId: this.userId
			}]
		} });
	}
	async deleteReaction(e) {
		let t = this.provider.getThreadComment(e.threadId, e.commentId, !0);
		if (!t) throw Error("Comment not found");
		this.provider.updateComment(e.threadId, e.commentId, { data: {
			...t.data,
			reactions: (t.data?.reactions || []).filter((t) => t.emoji !== e.emoji && t.userId !== this.userId)
		} });
	}
	getThread(e) {
		let t = this.provider.getThread(e);
		if (!t) throw Error("Thread not found");
		return this.tiptapThreadToThreadData(t);
	}
	getThreads() {
		return new Map(this.provider.getThreads().map((e) => [e.id, this.tiptapThreadToThreadData(e)]));
	}
	subscribe(e) {
		let t = () => {
			e(this.getThreads());
		};
		return this.provider.watchThreads(t), () => {
			this.provider.unwatchThreads(t);
		};
	}
};
//#endregion
export { d as CommentMark, h as CommentsExtension, _ as DefaultThreadStoreAuth, i as ThreadStore, g as ThreadStoreAuth, v as TiptapThreadStore };

//# sourceMappingURL=comments.js.map